import { SnippetLanguage } from 'components/snippet/SnippetLanguage';

const DEFAULT_LANGUAGE = SnippetLanguage.HTML;

export { DEFAULT_LANGUAGE };
